// extracted by mini-css-extract-plugin
export default {"desctiption":"DescriptionList_desctiption__XAfuP","desctiptionCollapse":"DescriptionList_desctiptionCollapse__G76d2","showDescription":"DescriptionList_showDescription__yAwjw"};